<template>
    <div>
        <div class="slc--panel slc--panel__output" key="outputs" v-show="validationPassed">
            <div class="slc--column">
                <h3 class="slc--label__header slc--label__tight slc--left">Average Gallons of Fuel Dropped Per Stop</h3>
                <div class="slc--column-container slc--column-container__outputs">
                    <div class="slc--column">
                        <div class="slc--label slc--label__tight">SmartLid</div>
                        <div class="slc--text-output" id="smartLidOutput">{{smartlidGallonsFilledPerStop}}</div>
                    </div>
                    <div class="slc--column">
                        <div class="slc--label slc--label__tight">Standard Lid</div>
                        <div class="slc--text-output" id="standardLidOutput">{{traditionalGallonsFilledPerStop}}</div>
                    </div>
                </div>
                <h3 class="slc--label__header slc--label__tight slc--left">Annual Savings</h3>
                <div class="slc--column-container slc--column-container__outputs">
                    <div class="slc--column">
                        <div class="slc--label slc--label__tight slc--label__has-message">Cost Savings <div class="slc--message slc--message__information">The estimated total cost saved on all monitored accounts per year.</div></div>
                        <div class="slc--text-output" id="costSavingsOutput">{{annualSavings}}</div>
                    </div>
                    <div class="slc--column">
                        <div class="slc--label slc--label__tight slc--label__has-message">Trip Savings <div class="slc--message slc--message__information">The estimated number of technical/bobtail stops elmininated using SmartLid.</div></div>
                        <div class="slc--text-output" id="tripSavingsOutput">{{tripsSavedPerYear}}</div>
                    </div>
                    <div class="slc--column">
                        <div class="slc--label slc--label__tight slc--label__has-message">Savings per Customer <div class="slc--message slc--message__information">The estimated total amount saved per customer per year.</div></div>
                        <div class="slc--text-output" id="savingsPerCustomerOutput">{{annualSavingsPerCustomer}}</div>
                    </div>
                </div>
                <h3 class="slc--label__header slc--label__tight slc--left">Long-Term Savings <small>Monitor and fees included</small></h3>
                <div class="slc--column-container slc--column-container__outputs">
                    <div class="slc--column">
                        <div class="slc--label slc--label__tight">5 Years</div>
                        <div class="slc--text-output" id="fiveYearsOutput">{{fiveYearSavings}}</div>
                    </div>
                    <div class="slc--column">
                        <div class="slc--label slc--label__tight">10 Years</div>
                        <div class="slc--text-output" id="tenYearsOutput">{{tenYearSavings}}</div>
                    </div>
                    <div class="slc--column">
                        <div class="slc--label slc--label__tight">15 Years</div>
                        <div class="slc--text-output" id="fifteenYearsOutput">{{fifteenYearSavings}}</div>
                    </div>
                </div>
                <div class="slc--message slc--message__results" v-html="resultsMessage"> </div>
                <button class="slc--button" v-on:click="reset">Reset Calculator</button>
            </div>
        </div>
        <div class="slc--panel slc--panel__input" key="inputs" v-show="!validationPassed">
            <div class="slc--error slc--center">{{errorGeneric}}</div>
                <div class="slc--column-container slc--column-container__input-groups">
                    <div class="slc--column"><div class="slc--input-group">
                        <div class="slc--column-container slc--column-container__default">
                            <div class="slc--column"><img src="/ResourcePackages/Worthington/assets/dist/images/smartlid/slc-tank.png" alt="42# Tank"></div>
                            <div class="slc--column slc--right"><img src="/ResourcePackages/Worthington/assets/dist/images/smartlid/slc-smartlid-vertical-horizontal.png" alt="SmartLid Tanks"></div>
                        </div>
                        <label class="kicker">Number of Customers</label>
                        <div class="slc--input slc--input__range">
                            <input type="range" class="slc--range" v-model="numberOfCustomers" v-on:input="setSlider($event,'numberOfCustomers')" v-on:change="setSlider($event,'numberOfCustomers')" min="1" max="20000" step="1">
                            <div class="slc--range-handle" ref="handle"></div>
                            <input type="text" class="slc--range-output" ref="handleInput" @focus="setSlider2($event,'numberOfCustomers',true)" v-model="numberOfCustomers2" v-on:change="validateNumberOfCustomers($event)" v-on:input="validateNumberOfCustomers($event)" min="1" max="20000" maxlength="6">
                        </div>
                        <div class="slc--error">{{errorNumberOfCustomers}}</div>
                    </div>
                    <div class="slc--input-group slc--input-group__columns">
                        <label class="slc--label">Number of Tanks per Customer</label>
                        <div class="slc--input">
                            <input type="text" maxlength="5" class="slc--input-group--quantity" v-model="tanksPerCustomer" v-on:input="validateTanksPerCustomer">
                        </div>
                        <div class="slc--error">{{errorTanks}}</div>
                    </div>
                    <div class="slc--input-group slc--input-group__columns">
                        <label class="slc--label">Tank Size</label>
                        <div class="slc--input slc--input__select">
                            <select v-model="tankSize">
                                <option value="47.2">200-pound</option>
                                <option value="96">420-pound</option>
                                <option value="200">250 Gallon</option>
                                <option value="256">320 Gallon</option>
                                <option value="400">500 Gallon</option>
                                <option value="800">1000 Gallon</option>
                            </select>
                        </div>
                        <div class="slc--error">{{errorTankSize}}</div>
                    </div>
                    <div class="slc--input-group slc--input-group__columns">
                        <label class="slc--label">Cost Per Refill Stop</label>
                        <div class="slc--input">
                            <input type="text" placeholder="$" v-model="costPerRefillStop" v-on:input="validateCostPerRefillStop">
                            <!-- Input changed from type number to type text to account for required dollar sign -->
                        </div>
                        <div class="slc--error">{{errorStopCost}}</div>
                    </div>
                </div>
                <div class="slc--column">
                    <div class="slc--input-group">
                        <div class="slc--column-container slc--column-container__default">
                            <div class="slc--column slc--center"><img src="/ResourcePackages/Worthington/assets/dist/images/smartlid/slc-truck.png" alt="Tank Truck"></div>
                        </div>
                        <label class="kicker">Average Gallons a Year per Customer</label>
                        <div class="slc--input slc--input__range">
                            <input type="range" class="slc--range" v-model="gallonsPerYearPerCustomer" v-on:input="setSlider($event,'gallonsPerYearPerCustomer')" v-on:change="setSlider($event,'gallonsPerYearPerCustomer')"  step="1" min="1" max="500000">
                            <div class="slc--range-handle"></div>
                            <input type="text" class="slc--range-output" @focus="setSlider2($event,'gallonsPerYearPerCustomer',true)" v-model="gallonsPerYearPerCustomer2" v-on:change="validateAverageGallons($event)" v-on:input="validateAverageGallons($event)" min="1" max="500000" maxlength="7">
                        </div>
                        <div class="slc--error">{{errorGallonsPerYearPerCustomer}}</div>
                    </div>
                    <div class="slc--input-group slc--input-group__columns">
                        <label class="slc--label">Average Level at Refill</label>
                        <div class="slc--input slc--input__select">
                            <select v-model="avergeLevelAtRefill">
                                <option v-for="index in 99" :key="index" :value="index">{{index}}%</option>
                            </select>
                        </div>
                        <div class="slc--error">{{errorLevel}}</div>
                    </div>
                </div>
            </div>
            <div>
                <button class="slc--button" v-on:click="validate">Calculate</button>
            </div>
        </div>
    </div>
</template>


<script lang="ts">

export default {
	name: "SmartLid",
    data: function() {
        return {
            numberOfCustomers: 1, // Default value
            numberOfCustomers2: 1,
            tanksPerCustomer: 1, // Default value
            tankSize: 47.2, // Default value
            costPerRefillStop: '',
            gallonsPerYearPerCustomer: 1, // Default value
            gallonsPerYearPerCustomer2: 1, // Default value
            avergeLevelAtRefill: '50', // Default value
            perCustomerTankCapacity: 0,
            smartlidRefillPercent: 0.25, // Constant
            smartlidRefillPoint: 0,
            traditionalRefillPoint: 0,
            smartlidGallonsFilledPerStop: 0,
            traditionalGallonsFilledPerStop: 0,
            smartlidStopsPerYearPerCustomer: 0,
            traditionalStopsPerYearPerCustomer: 0,
            tripsSavedPerCustomer: 0,
            tripsSavedPerYear: 0,
            annualFee: 18, // Constant
            annualSavingsPerCustomer: 0,
            annualSavings: 0,
            smartlidHardwareCost: 120, // Constant
            fiveYearSavings: 0,
            tenYearSavings: 0,
            fifteenYearSavings: 0,
            validationPassed: false,
            handleWidth: '', // Range slider
            handleInputWidth: '',
            errorGeneric: '',
            errorNumberOfCustomers: '',
            errorGallonsPerYearPerCustomer: '',
            errorTanks: '',
            errorTankSize: '',
            errorStopCost: '',
            errorLevel: '',
            resultsMessage: ''
        }
    },
    methods: {
        validate: function(event) {
            // Stop default behavior on embedded page
            event.preventDefault();
            event.stopPropagation();
            this.validationPassed = true;
            // Scroll to top
            this.scrollToTop();
            // Number of customres
            if (this.numberOfCustomers2 == '') {
                this.validationPassed = false;
                this.errorNumberOfCustomers = 'Please enter the number between 1 and 20,000.';
            }
            else {
                this.errorTanks = '';
            }
            // Average gallons per year per customer
            if (this.gallonsPerYearPerCustomer2 == '') {
                this.validationPassed = false;
                this.errorGallonsPerYearPerCustomer = 'Please enter the number between 1 and 500,000.';
            }
            else {
                this.errorTanks = '';
            }
            // Tanks per customer
            if (!Number.isInteger(parseInt(this.tanksPerCustomer)) || this.tanksPerCustomer <= 0) {
                this.validationPassed = false;
                this.errorTanks = 'Please enter the number of tanks.';
            }
            else {
                this.errorTanks = '';
            }
            // Cost per refill stop
            var costPerRefillStopTemp = this.costPerRefillStop;
            if (this.costPerRefillStop == '') {
                this.validationPassed = false;
                this.errorStopCost = 'Please enter a dollar amount.';
            }
            else {
                this.errorStopCost = '';
            }
            // Average level at refill
            if (this.avergeLevelAtRefill == '') {
                this.validationPassed = false;
                this.errorLevel = 'Please select a percentage.';
            }
            else {
                this.errorLevel = '';
            }
            if (this.validationPassed) {
                this.errorGeneric = '';
                this.calculate();
            }
            else {
                this.errorGeneric = 'There have been some errors.';
            }
        },
        validateTanksPerCustomer: function(event) {
            var numbersTest = /^[-,0-9]+$/;
            var tempValue = this.tanksPerCustomer;
            if (!this.tanksPerCustomer.match(numbersTest) || this.tanksPerCustomer == 0) {
                tempValue = this.tanksPerCustomer.slice(0,-1);
                this.tanksPerCustomer = tempValue;
            }
            else {
                this.tanksPerCustomer = this.convertToNumberString(tempValue);
            }
        },
        validateCostPerRefillStop: function(event) {
            var numbersTest = /^\$?[-,0-9]+$/;
            var tempValue = this.costPerRefillStop;
            if (!this.costPerRefillStop.match(numbersTest)) {
                tempValue = this.costPerRefillStop.slice(0,-1);
            }
            else {
                tempValue = this.convertToString(tempValue);
                tempValue = this.convertToNumberString(tempValue);
                tempValue = this.convertToDollars(tempValue);
            }
            this.costPerRefillStop = tempValue;
        },
        validateNumberOfCustomers: function(event) {
            var input = event.target;
            var max = this.convertToNumber(input.max);
            var numbersTest = /^[-,0-9]+$/;
            var tempValue = this.numberOfCustomers2;
            if (!this.numberOfCustomers2.match(numbersTest) || this.convertToNumber(this.numberOfCustomers2) == 0 || this.convertToNumber(this.numberOfCustomers2) > max) {
                // console.log(this.numberOfCustomers2);
                tempValue = this.numberOfCustomers2.slice(0,-1);
                this.numberOfCustomers2 = tempValue;
            }
            else {
                tempValue = this.convertToString(tempValue);
                tempValue = this.convertToNumberString(tempValue);
                this.numberOfCustomers2 = tempValue;
                this.setSlider2(event,'numberOfCustomers');
            }
        },
        validateAverageGallons: function(event) {
            var input = event.target;
            var max = this.convertToNumber(input.max);
            var numbersTest = /^[-,0-9]+$/;
            var tempValue = this.gallonsPerYearPerCustomer2;
            if (!this.gallonsPerYearPerCustomer2.match(numbersTest) || this.convertToNumber(this.gallonsPerYearPerCustomer2) == 0 || this.convertToNumber(this.gallonsPerYearPerCustomer2) > max) {
                tempValue = this.gallonsPerYearPerCustomer2.slice(0,-1);
                this.gallonsPerYearPerCustomer2 = tempValue;
            }
            else {
                tempValue = this.convertToString(tempValue);
                tempValue = this.convertToNumberString(tempValue);
                this.gallonsPerYearPerCustomer2 = tempValue;
                this.setSlider2(event,'gallonsPerYearPerCustomer');
            }
        },
        setSlider: function(event,connect) {
            /* Based on https://codepen.io/chriscoyier/pen/eYNQyPe */
            var input = event.target;
            var val = input.value;
            var min = input.min;
            var max = input.max;
            var handleLocation = Number(((val - min) * 100) / (max - min));
            var specialSauce = this.getSpecialSauce(handleLocation);

            let nextInput = input.nextElementSibling as HTMLElement;
            let nextNextInput = input.nextElementSibling.nextElementSibling as HTMLElement;

            if (handleLocation >= 50) {
                nextInput.style.left = 'calc(' + handleLocation + '% - ' + (this.handleWidth * specialSauce) + 'px)';
                nextNextInput.style.left = 'calc(' + handleLocation + '% - ' + (this.handleWidth * specialSauce + this.handleInputWidth/2) + 'px)';
            }
            else {
                nextInput.style.left = 'calc(' + handleLocation + '% + ' + (this.handleWidth * specialSauce) + 'px)';
                nextNextInput.style.left = 'calc(' + handleLocation + '% + ' + (this.handleWidth * specialSauce - this.handleInputWidth/2) + 'px)';
            }
            if (connect == 'numberOfCustomers') {
                this.numberOfCustomers2 = this.convertToNumberString(val);
            }
            else {
                this.gallonsPerYearPerCustomer2 = this.convertToNumberString(val);
            }
        },
        setSlider2: function(event,connect,reset) {
            var input = event.target;
            var val;
            if (reset == true) {
                val = 1;
            }
            else {
                val = this.convertToNumber(input.value);
            }
            var min = input.min ? input.min : 0;
            var max = input.max ? input.max : 100;
            var handleLocation = Number(((val - min) * 100) / (max - min));
            var specialSauce = this.getSpecialSauce(handleLocation);

            let previous = input.previousElementSibling as HTMLElement;
            let inputElement = input as HTMLElement;

            if (handleLocation >= 50) {
                previous.style.left = 'calc(' + handleLocation + '% - ' + (this.handleWidth * specialSauce) + 'px)';
                inputElement.style.left = 'calc(' + handleLocation + '% - ' + (this.handleWidth * specialSauce + this.handleInputWidth/2) + 'px)';
            }
            else {
                previous.style.left = 'calc(' + handleLocation + '% + ' + (this.handleWidth * specialSauce) + 'px)';
                inputElement.style.left = 'calc(' + handleLocation + '% + ' + (this.handleWidth * specialSauce - this.handleInputWidth/2) + 'px)';
            }
            if (connect == 'numberOfCustomers') {
                this.numberOfCustomers2 = this.convertToNumberString(val);
                this.numberOfCustomers = val;
            }
            else {
                this.gallonsPerYearPerCustomer2 = this.convertToNumberString(val);
                this.gallonsPerYearPerCustomer = val;
            }
        },
        getSpecialSauce: function(handleLocation) {
            return Math.abs(handleLocation - 50) / 100;
        },
        convertToDollars: function(value) {
            if (value.indexOf('$') != 0) {
                value = '$' + value;
            }
            return value;
        },
        convertToString: function(value) {
            value = String(value).replace('$','');
            return value;
        },
        convertToNumber: function(value) {
            value = String(value).replace('$','').replace(/\,/g,'');
            value = Number(value);
            return value;
        },
        convertToNumberString: function(value) {
            value = String(value).replace('$','').replace(/\,/g,'');
            value = Number(value).toLocaleString();
            return value;
        },
        showHideError: function(id,message) {
            document.getElementById(id).innerText = message;
        },
        calculate: function() {
            // Convert to numbers
            this.tanksPerCustomer = this.convertToNumber(this.tanksPerCustomer);
            this.costPerRefillStop = this.convertToNumber(this.costPerRefillStop);
            // Calculate
            this.perCustomerTankCapacity = this.tanksPerCustomer * this.tankSize;
            this.smartlidRefillPoint = this.perCustomerTankCapacity * this.smartlidRefillPercent;
            this.traditionalRefillPoint = this.perCustomerTankCapacity * this.avergeLevelAtRefill / 100; // Convert to a percentage
            this.smartlidGallonsFilledPerStop = (this.perCustomerTankCapacity - this.smartlidRefillPoint).toFixed(1).replace('.0','');
            this.traditionalGallonsFilledPerStop = (this.perCustomerTankCapacity - this.traditionalRefillPoint).toFixed(1).replace('.0','');
            this.smartlidStopsPerYearPerCustomer = this.gallonsPerYearPerCustomer / this.smartlidGallonsFilledPerStop;
            this.traditionalStopsPerYearPerCustomer = this.gallonsPerYearPerCustomer / this.traditionalGallonsFilledPerStop;
            this.tripsSavedPerCustomer = this.traditionalStopsPerYearPerCustomer - this.smartlidStopsPerYearPerCustomer;
            this.tripsSavedPerYear = Math.round(this.tripsSavedPerCustomer * this.numberOfCustomers);
            this.annualSavingsPerCustomer = this.tripsSavedPerCustomer * this.costPerRefillStop - this.annualFee;
            this.annualSavings = this.annualSavingsPerCustomer * this.numberOfCustomers;
            this.fiveYearSavings = this.annualSavings * 5 - this.numberOfCustomers * this.tanksPerCustomer * this.smartlidHardwareCost;
            this.tenYearSavings = this.annualSavings * 10 - this.numberOfCustomers * this.tanksPerCustomer * this.smartlidHardwareCost;
            this.fifteenYearSavings = this.annualSavings * 15 - this.numberOfCustomers * this.smartlidHardwareCost; // Removed tanks per customer as one Smartlid can be linked to all tanks
            // Round
            this.annualSavingsPerCustomer = Math.max(0,Math.round(this.annualSavingsPerCustomer));
            this.annualSavings = Math.max(0,Math.round(this.annualSavings));
            this.fiveYearSavings = Math.max(0,Math.round(this.fiveYearSavings));
            this.tenYearSavings = Math.max(0,Math.round(this.tenYearSavings));
            this.fifteenYearSavings = Math.max(0,Math.round(this.fifteenYearSavings));
            // Check for bad results
            if (this.annualSavingsPerCustomer <= 0 || this.annualSavings <= 0 || this.fifteenYearSavings <= 0) {
                this.resultsMessage = 'Your fleet may require a unique solution. We remain dedicated to helping you save time and money. Please <a href="mailto:cylinders@worthingtonindustries.com">contact us</a> to see how SmartLid can help improve your operations.';
            }
            else {
                this.resultsMessage = '';
            }
            // Convert to dollars and add commas
            this.smartlidGallonsFilledPerStop = this.convertToNumberString(this.smartlidGallonsFilledPerStop);
            this.traditionalGallonsFilledPerStop = this.convertToNumberString(this.traditionalGallonsFilledPerStop);
            this.tripsSavedPerYear = this.convertToNumberString(this.tripsSavedPerYear);
            this.annualSavingsPerCustomer = this.convertToDollars(this.convertToNumberString(this.annualSavingsPerCustomer));
            this.annualSavings = this.convertToDollars(this.convertToNumberString(this.annualSavings));
            this.fiveYearSavings = this.convertToDollars(this.convertToNumberString(this.fiveYearSavings));
            this.tenYearSavings = this.convertToDollars(this.convertToNumberString(this.tenYearSavings));
            this.fifteenYearSavings = this.convertToDollars(this.convertToNumberString(this.fifteenYearSavings));
        },
        reset: function(event) {
            // Stop default behavior on embedded page
            event.preventDefault();
            event.stopPropagation();
            this.numberOfCustomers = 1;
            this.numberOfCustomers2 = 1,
            this.tanksPerCustomer = 1;
            this.tankSize = 47.2;
            this.costPerRefillStop = '';
            this.gallonsPerYearPerCustomer = 1;
            this.gallonsPerYearPerCustomer2 = 1;
            this.avergeLevelAtRefill = '50';
            this.validationPassed = false;
            this.resetSliders();
            this.scrollToTop();
        },
        resetSliders: function() {
            var outputs = document.getElementsByClassName('slc--range-handle');
            for (var k=0; k<outputs.length; k++) {
                let outputElement = outputs[k] as HTMLElement;
                let outputElementNext = outputs[k].nextElementSibling as HTMLElement;
                outputElement.style.left = this.handleWidth/2 + 'px';
                outputElementNext.style.left = 'calc(' + (this.handleWidth/2 - this.handleInputWidth/2) + 'px)';
            }
        },
        scrollToTop: function() {
            // Get height of fixed header (if present)
            var headerHeight = 0;
            var tempHeight;
            if (document.getElementsByClassName('navbar').length == 2) {
                let navBar1 = document.getElementsByClassName('navbar')[0] as HTMLElement;
                let navBar2 = document.getElementsByClassName('navbar')[1] as HTMLElement;
                tempHeight = navBar1.offsetHeight + navBar2.offsetHeight;
                headerHeight = tempHeight;
            }
            var slcLocation = document.getElementById('slc').offsetTop - headerHeight;
            // console.log('headerHeight=' + headerHeight);
            // console.log('offsetTop=' + document.getElementById('slc').offsetTop);
            document.getElementById('slc').scrollIntoView();
            document.querySelector('body').scrollTo(0,slcLocation);
        },
        initPolyfills: function() {
            // ES6 integer fix
            Number.isInteger = Number.isInteger || function(value) {
                return typeof value === "number" &&
                        isFinite(value) &&
                        Math.floor(value) === value;
            };
            // iPhone hover fix
            document.addEventListener("click", x=>0)
        }
    },
    mounted: function() {
        if (this.$refs.handle.clientWidth > 0) {
            this.handleWidth = this.$refs.handle.clientWidth;
        }
        if (this.$refs.handleInput.clientWidth > 0) {
            this.handleInputWidth = this.$refs.handleInput.clientWidth;
        }
        this.initPolyfills();
    }
};
</script>
